export default "__VITE_ASSET__Dq12iZH2__"